<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { propertyService } from "../../../services/propertyservice/property.service";
import { projectService } from "../../../services/projectservice/project.service";
import { bookingService } from "../../../services/bookingservice/booking.service";
import { saleService } from "../../../services/saleservice/sale.service";
import { servicehelpers } from "../../../services/servicehelpers";
import List from "../../../components/list";
import Screen from "../../../components/screen";
import Fastview from "@/components/property-fastview";
import i18n from "../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Properties List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    List, 
    Fastview,
  },
  data() {
    return {
      ...Screen.Alert,
      ...Screen.Locate,
      propertyData: {},
      typeData: {},
      groupData: {},
      floorData: {},
      projectData: {},
      statusData: {},
      mergeData: {},
      fetchingStats: false,
      title: "Properties List",

      viewTitle: '',
      viewObject: null,

      valueMergeProperty: (this.$route.path == '/additional/property-master')

    };
  },
  mounted() {

    // this.valueMergeProperty = (this.$route.path == '/additional/property-master');
    
    // this.loadingpropertyTypeData();
    this.loadingData();
    this.loadingprojectData();
    this.loadingpropertyStatusData();

  },

  methods: {
    loadingData: function(param = '') {
      this.fetchingStats = false;
      propertyService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          let data = response.data;
          
          data.forEach((item,index)=>{
            if (this.$moment().isBefore(item.temp_expired)) {
              data[index].customer_id = item.temp_customer_id;
              data[index].customer = item.tempCustomer;
              data[index].customer_en = item.tempCustomer_en;

              // data[index].property_status_id = item.temp_type == 1 ? 4 : 2;
              // data[index].color = item.temp_type == 1 ? 'light' : 'warning';
              // data[index].status = (item.temp_type == 1 ? "បិទរហូត" : "កក់រហូត") + 
              //                     '<br/><div style="font-size: 6.5pt; margin-top: 5px;">' + this.$moment(item.temp_expired).format('DD-MM-YYYY') + '</div>';
              // data[index].status_en = (item.temp_type == 1 ? "Blocked" : "Booked") + 
              //                     '<br/><div style="font-size: 6.5pt"> ' + this.$moment(item.temp_expired).format('DD-MM-YYYY') + '</div>';
              
              if(item.temp_type == 1) {
                data[index].property_status_id = 4;
                data[index].color = 'light';
                data[index].status = 'បិទរហូត' + '<br/><div style="font-size: 6.5pt; margin-top: 5px;">' + this.$moment(item.temp_expired).format('DD-MM-YYYY') + '</div>';
                data[index].status_en = 'Blocked' + '<br/><div style="font-size: 6.5pt"> ' + this.$moment(item.temp_expired).format('DD-MM-YYYY') + '</div>';
              }
              
            } 
          });

          response.data = data;
          this.propertyData = response;

          // console.log(JSON.stringify(this.propertyData));
        });
    },

    loadingpropertyTypeData: function() {
      servicehelpers.getPropertyTypeData().then(response => {
        this.typeData = response;
      });
    },

    loadingpropertyFloorData: function(projectId = 0) {
      servicehelpers.getFloorData(projectId).then(response => {
        this.floorData = response;
        // console.log(this.floorData);

        // console.log(JSON.stringify(this.floorData.data));
      });
    },

    loadingpropertyGroupData: function(projectId = 0) {
      servicehelpers.getGroupData(projectId).then(response => {
        this.groupData = response;
      });
    },

    loadingpropertyStatusData: function() {
      servicehelpers.getPropertyStatusData().then(response => {
        this.statusData = response;
      });
    },

    loadingprojectData: function() {
      projectService.getList()
        .then(response => {
          this.projectData = response;

          // console.log(JSON.stringify(this.projectData.data));
        });
    },

    deleted: function(id) {

      let obj = this.propertyData.data.find(item => item.id === id);

      console.log(obj.property_status_id);

      if(obj.property_status_id == 3) {
        saleService.removeByProperty(id)
        .then(response => {
        
          // this.saleData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
      } else if(obj.property_status_id == 2) {
        bookingService.removeByProperty(id)
        .then(response => {
        
          // this.bookingData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
      } else {
        propertyService.remove(id)
        .then(response => {
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
      }
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "property-add",
          });
    },
    projectChanged: function(event) {
      // console.log("change::out ", event);
      this.loadingpropertyFloorData(event);
      this.loadingpropertyGroupData(event);
      // this.floorData.data = [];
      // this.project = event;
      // this.loadingPropertyData(this.project);

      this.mergeData = [{id: 1, label: i18n.t('property.merge.text')}];
    },

    unKeepClick: function(id) {

      let obj = {
        property_status_id: 1,
        temp_note: '',
        temp_type: 0,
        temp_customer_id: 0,
        temp_expired: '1979-01-01'
      };

      propertyService.update(id, obj)
        .then(response => {

          console.log(response);
          
          if(response.status == 200) {
            this.$router.go();
          }
        
      });
    },

    moreClick: function(event, id) {
      if(event == 'unkeep') {
        this.$swal.fire({
          title: i18n.t('general.cancel-confirm.title'),
          text: i18n.t('property.unkeep-message'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.ok'),
          cancelButtonText: i18n.t('general.cancel')
        }).then(result => {
          if (result.value) {
            this.unKeepClick(id);
          }
        });
      }
    },

    clickFastView(event) {
      this.viewTitle = event.name;
      this.viewObject = event.object;
      this.$refs['fast-view'].show();

      // console.log(JSON.stringify(event.object));
    },
  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'property-add'}"
    :buttons="[{icon: 'bx bx-edit', title: 'property.update-price.text', link: 'property-update-price'}]"
    :title="$t('menuitems.property.text')" />
    <Fastview 
      id="fast-view"
      ref="fast-view"
      :title="viewTitle"
      :item="viewObject"
      :filters="$options.filters"
    /> 
    <List v-bind:dataList="propertyData" 
          @more="moreClick"
          @view="clickFastView"
          v-bind:edit="{link: 'property-edit'}"
          v-bind:deletes="[deleted, null]"
          v-bind:view="{link: 'property-view'}"
          v-bind:more="{
            sub: [{
              name: 'property.contract', icon:'bx bx-file', link: 'property/contract', query: 'propertyid', column: 'id', show: {column: 'property_status_id', value: 3}
            }, {
              name: 'property.keep', icon:'bx bx-save', link: 'property-keep', column: 'id', show: {column: 'property_status_id', value: 1}
            }, {
              name: 'property.book', icon:'bx bx-calendar-check', link: 'booking/add', query: 'propertyid', column: 'id', show: {column: 'property_status_id', value: 1}
            }, {
              name: 'property.sell', icon:'bx bx-cart', link: 'sale/add', query: 'propertyid', column: 'id', show: {column: 'property_status_id', value: 1}
            }, {
              name: 'property.sell', icon:'bx bx-cart', link: 'sale/add', query: 'propertyid', column: 'id', show: {column: 'property_status_id', value: 2}
            }, {
                name: 'booking.delay', icon:'bx bx-time-five', link: 'property-book-delay', column: 'id', show: {column: 'property_status_id', value: 2}
            }, {
              name: 'property.block', icon:'bx bx-block', link: 'property-block', column: 'id', show: {column: 'property_status_id', value: 1}
            }, {
              name: 'property.unkeep', icon:'bx bx-up-arrow-alt', action: 'unkeep', link: 'property-unkeep', column: 'id', show: {column: 'property_status_id', value: 4}
            }, {
              name: 'property.unkeep', icon:'bx bx-up-arrow-alt', action: 'unkeep', link: 'property-unkeep', column: 'id', show: {column: 'property_status_id', value: 5}
            }, {
              name: 'sale.schedule.view', icon: 'bx bx-table', link: 'properties/payment_schedule', query: 'propertyid', column: 'id', show: {column: 'property_status_id', value: 3}, target: '_blank'
            }, {
              name: 'sale.commission', icon: 'bx bx-certification', link: 'property-contract', column: 'id', show: {column: 'property_status_id', value: 3}, target: '_blank'
            }, {
              name: 'sale.transfer-to-other', icon: 'bx bx-transfer-alt', link: 'property-contract', column: 'id', show: {column: 'property_status_id', value: 3}, target: '_blank'
            }, {
              name: 'property.change-term', icon: 'bx bx-money', link: 'sales/change-term', query: 'propertyid', column: 'id', show: {column: 'property_status_id', value: 3}
            }, {
              name: 'property.merge.text', icon:'bx bx-git-merge', link: 'property-merge', column: 'id', show: {column: 'property_status_id', value: 1}
            }, {
              name: 'property.cancelation.text', icon: 'bx bx-block', link: 'property-cancelation', column: 'id', show: {column: 'property_status_id', value: 3}
            }, {
              name: 'property.cancelation.text', icon: 'bx bx-block', link: 'property-cancelation', column: 'id', show: {column: 'property_status_id', value: 2}
            }, {
              name: 'property.handover.text', icon: 'bx bx-check-double', link: 'property-handover', column: 'id', show: {column: 'property_status_id', value: 3}
            }, {
              name: 'booking.transfer-property.text', icon: 'bx bx-sync', link: 'booking/transfer', query: 'propertyid', column: 'id', show: {column: 'property_status_id', value: 2}
            }, {
              name: 'property.late-log', icon: 'bx bx-edit-alt', link: 'sale-late', column: 'id', show: {column: 'property_status_id', value: 3}
            }]
          }"
          v-bind:filter="{
            search: ['properties.code', 'properties.description'], 
            checkbox: [{
              title: 'property.merge.text',
              field: 'properties.merge_property_id',
              value: 0,
              operator: '!=',
              selected: this.valueMergeProperty
            }],
            dropdown: [{
              title: 'property.project',
              field: 'properties.project_id',
              data: this.projectData.data,
              method: (event) => projectChanged(event),
              default: 1,
              width: 2
            }, {
              title: 'property.status',
              field: 'properties.property_status_id',
              conditions: [{
                value: 2,
                fields: [{
                  name: 'properties.temp_type',
                  value: 2,
                  operator: '=',
                  conjuction: 'and'
                }, {
                  name: 'properties.temp_expired',
                  value: this.$moment().clone().format('YYYY-MM-DD'),
                  operator: '>=',
                  conjuction: 'and'
                }]
              }, {
                value: 4,
                fields: [{
                  name: 'properties.temp_type',
                  value: 1,
                  operator: '=',
                  conjuction: 'and'
                }, {
                  name: 'properties.temp_expired',
                  value: this.$moment().clone().format('YYYY-MM-DD'),
                  operator: '>=',
                  conjuction: 'and'
                }]
              }],
              data: this.statusData.data
            }, {
              title: 'property.group',
              field: 'properties.property_group_id',
              data: this.groupData.data
            }, {
              title: 'property.floor',
              field: 'properties.project_floor_id',
              show: 'number',
              data: this.floorData.data
              
            }]
          }"
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[{name: 'code', type: 'fast-view'}, {name: 'status', color: true}, {name: 'currency_en'}, {name: 'price', type: 'currency'}]"
          v-bind:fields="[ `code: ${$t('property.code')}`, `project: ${$t('property.project')}`, `customer: ${$t('menuitems.customer.text')}`, `type: ${$t('property.type')}`, 
            `price: ${$t('property.price')}`, `currency_en: ${$t('property.currency')}`, `status: ${$t('property.status')}`]" />
  </Layout>
</template>